var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "screen", attrs: { id: "workspace-selection-screen" } },
    [
      _c(
        "transition",
        { attrs: { name: "fadeLogin", mode: "out-in", appear: "" } },
        [
          _c(
            "div",
            { staticClass: "workspace-selection-container" },
            [
              _c("workspace-selection-header"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "workspace-selection-content-container" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "workspace-selection",
                      staticStyle: { position: "relative", overflow: "auto" }
                    },
                    [
                      _c("workspaces-list", {
                        attrs: { "search-from-parent": _vm.workspaceSearch },
                        on: {
                          "update-search": function($event) {
                            _vm.workspaceSearch = $event
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73336938", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73336938","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Workspaces.vue
// module id = null
// module chunks = 